import { TileOverlay } from '@mc/design-system'
import Image from 'components/LegacyImage'

const DesktopHeroImage = ({ src, alt }: { src: string; alt: string }) => (
  <Image
    className='mc-corners--sm'
    src={src}
    alt={alt}
    width={540}
    height={631}
    objectFit='cover'
    priority
  />
)

interface HeroDesktopDualImageTilesProps {
  img1Url: string
  img1Alt: string
  img2Url: string
  img2Alt: string
}

export const HeroDesktopDualImageTiles = ({
  img1Url,
  img1Alt,
  img2Url,
  img2Alt,
}: HeroDesktopDualImageTilesProps) => (
  <div className='col-8 offset-4'>
    <TileOverlay type='gradient-left' color='0,0,0' />
    <TileOverlay type='gradient-bottom' color='0,0,0' />
    <div className='col-10 offset-2 d-flex justify-content-end mc-mb-9'>
      <div className='mc-mt-10 mc-mr-2'>
        <DesktopHeroImage src={img1Url} alt={img1Alt} />
      </div>
      <div className='mc-mt-2'>
        <DesktopHeroImage src={img2Url} alt={img2Alt} />
      </div>
    </div>
  </div>
)
